import React, { useState } from "react";

export const Mail = () => {
  const [user, setUser] = useState({
    name: "",
    subject: "",
    message: "",
  });

  const { name, subject, message } = user;

  const onChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };
  return (
    <>
      <section className="mail">
        <div className="_mailWrapper">
          <div className="_mailText">
            <h1 className="h1BG">Send me a message!</h1>
            <p>
              Got a question or proposal, or just want to say hello? Go ahead.
            </p>
          </div>

          <form className="_mailForm">
            <div className="_row">
              <div className="rowI">
                <label for="name">Your Name</label>
                <input
                  type="text"
                  name="name"
                  value={name}
                  onChange={onChange}
                  placeholder="Enter your name"
                />
              </div>
              <div className="rowI">
                <label for="subject">Subject</label>
                <input
                  type="text"
                  value={subject}
                  onChange={onChange}
                  name="subject"
                  placeholder="Job Offer For Me"
                />
              </div>
            </div>

            <div className="_row">
              <div className="rowT">
                <label for="name">Your Message</label>
                <textarea
                  type="text"
                  name="message"
                  value={message}
                  onChange={onChange}
                  placeholder="Hi Femi,  nice to meet you, i love what i see you do, you inspire me. so i've got a job for you"
                ></textarea>
              </div>
            </div>

            <div className="_row">
              <a
                href={`mailto:ficazzosam@gmail.com?subject=${subject}&body=${message}`}
                target="_blank"
                rel="noopener noreferrer"
                className="shoot"
              >
                Shoot
                <span></span>
              </a>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};
